import { useEffect, useState } from "react";
import { DataContext } from "client/context/DataContext";

export const useSRAutosuggest = (res: DataContext) => {
  const [status, setStatus] = useState<string>("");

  useEffect(() => {
    const termLen = res.searchedTerm?.length || 0;

    if (!termLen) {
      setStatus("");
      return;
    }

    if (termLen < 3) {
      setStatus("Type in 3 or more characters for results");
      return;
    }
    const suggestedBrands = res.brands?.length
      ? `${res.brands?.length} brands `
      : "";
    const suggestedSearches = res.searches.suggested?.length
      ? `${res.searches.suggested?.length} searches `
      : "";
    const suggestedProducts = res.products?.length
      ? `${res.products?.length} products `
      : "";
    const and =
      (suggestedBrands || suggestedSearches) && suggestedProducts ? "and " : "";

    setStatus(
      `${res.searchedTerm} .
            A few suggestions available: ${suggestedBrands}${suggestedSearches}${and}${suggestedProducts}.
            Use Tab to review and Enter to select. Press Search button to get more results`,
    );
  }, [res]);

  return status;
};
